import { render, staticRenderFns } from "./afterDetail.vue?vue&type=template&id=23f0e97c&scoped=true&"
import script from "./afterDetail.vue?vue&type=script&lang=js&"
export * from "./afterDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f0e97c",
  null
  
)

export default component.exports